var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar',{attrs:{"mode":"Admin"}}),_c('router-view'),_c('LoginDialog',{attrs:{"mode":"Admin"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }